import { Children } from "react";
import styles from "./Badge.module.scss";

export type BadgePosition =
    | "top-right"
    | "top-left"
    | "bottom-left"
    | "bottom-right";

export type BadgeProps = React.PropsWithChildren<{
    /**
     * Count of notification items
     */
    count: number;
    /**
     * Max count shown before displaying + symbol
     */
    overflowCount?: number;
    /**
     * If true, show as dot without count
     */
    quiet?: boolean;
    /**
     * Alignment of badge relative to children
     */
    position?: BadgePosition;
    /**
     * Additional styles for component
     */
    className?: string;
    /**
     * Title for Accessability
     */
    title?: string;
}>;

export const Badge: React.FC<BadgeProps> = ({
    count,
    children,
    overflowCount = 9,
    quiet = false,
    position = "top-left",
    className,
    title,
}) => {
    const text = count > overflowCount ? `${overflowCount}+` : count;
    const hasChildren = Children.count(children) > 0;
    const badgeClassName = [
        styles[hasChildren ? "children" : "children-none"],
        styles[`position-${position}`],
        quiet ? styles.dot : styles.number,
    ].join(" ");

    return (
        <span
            className={[styles.wrapper, className].join(" ")}
            style={
                {
                    "--badge-offset": `${quiet ? -2 : -5}px`,
                } as React.CSSProperties
            }
        >
            <sup className={badgeClassName} aria-label={title}>
                {!quiet && text}
            </sup>
            {children}
        </span>
    );
};
